import { Link } from "react-router-dom";

export default function SiteFooter() {
  return (
    <footer className="mt-16 w-full border-t border-primary-800 bg-primary-950 text-primary-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 font-heading text-sm font-semibold text-primary-950">
                AV
              </span>
              <div className="flex flex-col leading-none">
                <span className="font-heading text-lg font-semibold text-background-50">韩国AV</span>
                <span className="mt-1 text-[10px] uppercase tracking-[0.2em] text-primary-300">Korean Film Archive</span>
              </div>
            </div>
            <p className="mt-5 max-w-md text-[13px] leading-7 text-primary-200">
              一个专注于韩国电影与电视剧资料的整理站。我们收录作品信息、剧情简介与专题片单，帮助影迷更快找到想看的作品。
            </p>
            <p className="mt-4 max-w-md text-[12px] leading-6 text-primary-300">
              本站所有内容均为资料索引与剧情介绍，不提供任何影片播放或下载服务，资源链接仅作界面演示。
            </p>
          </div>

          <div>
            <h3 className="text-[13px] font-semibold uppercase tracking-[0.16em] text-background-50">快速导航</h3>
            <ul className="mt-4 space-y-2.5 text-[13px]">
              {[
                { label: "首页", path: "/" },
                { label: "影视分类", path: "/category" },
                { label: "专题合集", path: "/special" },
                { label: "搜索作品", path: "/search" },
              ].map((item) => (
                <li key={item.path}>
                  <Link to={item.path} className="text-primary-200 transition-colors hover:text-accent-300">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-[13px] font-semibold uppercase tracking-[0.16em] text-background-50">关于本站</h3>
            <ul className="mt-4 space-y-2.5 text-[13px]">
              {[
                { label: "关于我们", path: "/about" },
                { label: "联系我们", path: "/contact" },
                { label: "剧情资讯", path: "/special" },
                { label: "意见反馈", path: "/contact" },
              ].map((item) => (
                <li key={item.label}>
                  <Link to={item.path} className="text-primary-200 transition-colors hover:text-accent-300">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="mt-5 flex items-center gap-2">
              {["ri-mail-line", "ri-weibo-line", "ri-wechat-line", "ri-youtube-line"].map((icon) => (
                <span
                  key={icon}
                  className="flex h-8 w-8 items-center justify-center rounded-md border border-primary-800 bg-primary-900 text-primary-200"
                >
                  <i className={`${icon} text-sm`} />
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-800 pt-6 text-[12px] text-primary-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2025 韩国AV 影视资料站 · 内容仅供影迷交流参考</p>
          <div className="flex flex-wrap items-center gap-4">
            <span className="whitespace-nowrap">友情链接：韩国电影资料馆（演示）</span>
            <Link to="/about" className="whitespace-nowrap transition-colors hover:text-accent-300">
              版权声明
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}